import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import BannerImage from "../../../assets/scw_banner_logo.svg";
import SamaveshLogo from "../../../assets/samavesh.svg";
import ScwLogo from "../../../assets/scw_logo.svg";
import PortalPanel from "./PortalPanel";

// Shared SAMAVESH left banner (desktop) used across the auth screens (login,
// forgot password, reset password) with the "Change" portal-switch behaviour.
const AuthBanner: React.FC = () => {
  const [showPortalPanel, setShowPortalPanel] = useState(false);

  return (
    <>
      <div className="hidden md:flex col-span-7 h-full relative overflow-hidden bg-[#003366]">
        <img
          src={BannerImage}
          width={602}
          height={694}
          alt="banner-image"
          className="w-full h-full object-cover"
        />
        {/* #003366 covers the left, fading out so the image shows on the right */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#003366] from-[35%] to-transparent to-[85%]" />
        {/* Overlay content matching the SAMAVESH banner */}
        <div className="absolute inset-0 flex flex-col px-12 py-10 text-white">
          <div className="flex-1 flex flex-col justify-center">
            <div className="flex items-center gap-4">
              <img
                src={SamaveshLogo}
                width={92}
                height={92}
                alt="samavesh-logo"
                className="h-20 w-20"
              />
              <div className="leading-none">
                <h1 className="!text-5xl font-bold tracking-wide">SAMAVESH</h1>
                <p className="!text-2xl text-white/85 !font-medium mt-2">
                  समावेश
                </p>
              </div>
            </div>

            <div className="h-[4px] w-full max-w-[620px] my-6 rounded-[4px] bg-[#FF671F]" />

            <h2 className="!text-3xl !font-medium mb-4">
              Justice. Equality. Dignity.
            </h2>
            <p className="!text-base leading-relaxed text-white/70 max-w-md">
              Single Access Mechanism for All Verticals of Empowerment &amp;
              Social Harmony - one unified gateway for every social justice
              service in India.
            </p>
          </div>

          <div className="-mx-12 -mb-10 px-8 py-6 border-t border-white/20 bg-[#003366] flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src={ScwLogo}
                width={44}
                height={44}
                alt="scw-logo"
                className="h-14 w-14 bg-white rounded-full p-2 object-contain"
              />
              <div className="leading-tight">
                <p className="!text-xs tracking-[0.2em] text-white/70 uppercase">
                  Signing Into
                </p>
                <p className="!text-xl !font-semibold">
                  Senior Citizens Welfare
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => setShowPortalPanel(true)}
              className="flex items-center gap-2 border border-gray-500 rounded-md px-4 py-2 text-sm text-gray-400 hover:bg-white/10 transition-colors"
            >
              <FontAwesomeIcon
                icon={faRightLeft}
                className="text-sm"
                size="sm"
              />
              Change
            </button>
          </div>
        </div>
      </div>

      <PortalPanel
        open={showPortalPanel}
        onClose={() => setShowPortalPanel(false)}
      />
    </>
  );
};

export default AuthBanner;
